module.exports = __webpack_public_path__ + "img/efatura.ee5fccca.png";